import React from "react";
import "./portfolio.css";
import text2 from "../../asset/textutils.png";
import text3 from "../../asset/foodpanda.png";
import text4 from "../../asset/Newsapp.png";
import text5 from "../../asset/iNotebook.png";
import text6 from "../../asset/task_managment.png";
import text7 from "../../asset/portfolio.png";

// use data from json

const data = [
  {
    id: 6,
    image: text7,
    title: "Portfolio",
    github: "https://github.com/rahulbatham767/Portfolio",
    demo: "https://rahulbatham767.github.io/Portfolio/",
  },
  {
    id: 1,
    image: text2,
    title: "textUtils",
    github: "https://github.com/rahulbatham767/TextUtils",
    demo: "https://rahulbatham767.github.io/TextUtils/",
  },

  {
    id: 4,
    image: text6,
    title: "Task Management",
    github: "http://github.com",
    demo: "https://rahulbatham767.github.io/task-managment-system/",
  },
  {
    id: 2,
    image: text5,
    title: "iNotebook",
    github: "http://github.com",
    demo: "https://inotebook-frontend-three.vercel.app/",
  },
  {
    id: 5,
    image: text3,
    title: "Food Panda",
    github: "https://github.com/rahulbatham767/foodpanda://github.com",
    demo: "https://rahulbatham767.github.io/foodpanda/#",
  },

  {
    id: 3,
    image: text4,
    title: "NewsApp",
    github: "https://github.com/rahulbatham767/Newsapi://github.com",
    demo: "https://github.com/rahulbatham767/Newsapi/blob/main/Note.txt",
  },
];

function portfolio() {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio_container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article
              className="portfolio__item"
              key={id}
              style={{ width: "22rem" }}
            >
              <div className="portfolio_item-image">
                <img src={image} alt="" />
              </div>
              <h3>{title}</h3>
              <div className="portfolio_cta">
                <a
                  href={github}
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  {title}
                </a>
                <a
                  href={demo}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default portfolio;
